import React from 'react';

import { TableSettingsConfig } from './types';

export type TableColumnVisibilityProps = Readonly<{
    settings: TableSettingsConfig;
    lockedColumns?: number[];
}>;

export default function TableColumnVisibility({ settings, lockedColumns }: TableColumnVisibilityProps) {
    return (
        <>
            {settings.columnNames.map((name, index) => {
                if (lockedColumns?.includes(index)) {
                    return null;
                }
                return (
                    <div key={index}>
                        <label>
                            <input
                                type="checkbox"
                                checked={!settings.hiddenColumns.includes(index)}
                                onChange={(e) => settings.setColumnVisibility(index, e.target.checked)}
                            />
                            <span className="ml-1">{name}</span>
                        </label>
                    </div>
                );
            })}
        </>
    );
}
